var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"section-action",attrs:{"to":_vm.to}},[_c('CButton',{attrs:{"color":"primary","variant":"outline","size":"sm"}},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }